// связано с ограничением SOWA для поля comment:
// https://stash.delta.sbrf.ru/projects/WSCHANNEL/repos/csi_pool_web_site_sowa/browse/CI04142569/CSI_POOL_WEB_SITE/services/schemes/json/CSI_POOL_WEB_SITE/v1/CSI_POOL_WEB_SITE.saveform.POST.rq.json?at=refs%2Fheads%2Frelease%2F03.011
export const MAX_USER_COMMENT_LENGTH = 2000;
